<template>
    <div class="ur-data-grid__content__freeze-row" :style="rowStyle" :class="rowClass"
            @mousedown="onRowClick" @mouseenter="setHover(true,$event)" @mouseleave="setHover(false,$event)"
            @dblclick="onDblClick">
        <!-- [CELL] Checkbox at first -->
        <checkbox-cell :value="row.__selected" v-if="gridInfo.opts.selectCheck"/>
        <!-- [CELL] Contents cell -->
        <content-cell v-for="field in gridInfo.freezeCols" :field="field" :value="row[field.value]" :key="field.value" ref="cells"/>
        <!-- [CELL] Accordion cell : Toggle Icon -->
        <accordion-cell :value="isAccord" @input="toggleAccordion" vertical v-if="!!gridInfo.opts.accordion"/>
    </div>
</template>


<script>
import checkboxCell  from '../cell/urDataGridContentCheckCell.vue';
import accordionCell from '../cell/urDataGridContentAccordionCell.vue';
import contentCell   from '../cell/urDataGridContentCell.vue';
import rowMixin from "./urDataGridContentRowMixin";

export default {
    name : 'urDataGridContentFreezeRow',
    mixins : [rowMixin], // @see for "row" props
    components : {contentCell, checkboxCell, accordionCell},
    inject : ['gridInfo'],
    watch : {
        'row.__editMode':{handler(v,w) {
            // 1. Focus first cell
            // 1.1 Check first
            if(!v) return;
            // 1.2 Focus something
            this.focusFirst();
        }}
    },
    computed : {
        rowStyle() {
            var style = {}
            style.height= this.gridInfo.opts.rowHeight+'px'
            style.width = this.gridInfo.vars_freezeWidth+'px'
            return style
        },
        isAccord() {
            if(!this.gridInfo.vars_accordionRow) return null;
            return this.row.__id === this.gridInfo.vars_accordionRow.__id;
        }
    },
}
</script>